import { getApiUrl } from '../../../config/api';
import { post } from '../../../utils/request-manager';

export default class AddModuloViewController {
  constructor() {
    this.modulo = {
      Nombre: '',
      Ruta: '',
      RutaApi: '',
      Permisos: '',
      EsActivo: true
    };
    this.saving = false;
    this.error = null;
  }

  // Inicializar el controlador
  initialize() {
    this.resetForm();
  }

  // Resetear formulario
  resetForm() {
    this.modulo = {
      Nombre: '',
      Ruta: '',
      RutaApi: '',
      Permisos: '',
      EsActivo: true
    };
    this.saving = false;
    this.error = null;
  }

  // Actualizar campo del formulario
  updateField(field, value) {
    if (field in this.modulo) {
      this.modulo[field] = value;
    }
  }

  // Validar formulario
  validateForm() {
    const errors = [];
    
    if (!this.modulo.Nombre || this.modulo.Nombre.trim() === '') {
      errors.push('El nombre es requerido');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  }

  // Guardar módulo
  async saveModulo() {
    if (this.saving) return { success: false, message: 'Ya se está guardando' };
    
    const validation = this.validateForm();
    if (!validation.isValid) {
      return {
        success: false,
        message: validation.errors.join(', ')
      };
    }

    this.saving = true;
    this.error = null;

    try {
      const formData = {
        Modulo: this.modulo
      };

      const response = await post(getApiUrl('/api/Modulo/guardar'), formData, {}, false);
      
      this.saving = false;
      
      if (response.data.Number > 0) {
        return {
          success: true,
          message: 'Módulo guardado con éxito',
          data: response.data
        };
      } else {
        return {
          success: false,
          message: 'Error al guardar el módulo'
        };
      }
    } catch (error) {
      console.error('Error al guardar módulo:', error);
      this.saving = false;
      return {
        success: false,
        message: 'No se pudo guardar el módulo. Por favor, verifique los datos e intente nuevamente.'
      };
    }
  }
}